/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import Swiper from 'swiper';

export var ShotByShot = BaseControl.extend({
    init: function() {
        this._super();
        this.initSlider();
    },

    initSlider: function() {
        var $swiperContainer = this.$element.find('.swiper-container'),
            slideNumber = this.$element.find('.swiper-slide').length;

        if (slideNumber > 1) {
            this.swiper = new Swiper($swiperContainer, {
                loop: false,
                slidesPerView: 1,
                simulateTouch: true,
                speed: 1000,
                navigation: {
                    prevEl: $swiperContainer.find('.swiper-button-prev'),
                    nextEl: $swiperContainer.find('.swiper-button-next'),
                },
            });
        }
    },
});
